import React, {FC} from 'react';
import ListItemGroup from "./ListItemGroup";
import {isEvent} from "./utils";
import styles from "./styles/SchoolFeedList.module.scss";
import {
    IReactiveCourseWorkContentItem,
    IReactiveEventContentItem,
    IReactiveNewsContentItem,
} from "../SchoolFeedContentItem";
import {SocialItemModalNavigationProps} from "../../modals/SocialItemModal";
import classNames from "classnames";
import {useStores} from "../../../stores/useStores";

const SchoolFeedList: FC<{
    content: Array<IReactiveEventContentItem | IReactiveNewsContentItem | IReactiveCourseWorkContentItem>,
    allowCuration: boolean,
    showMedia: boolean,
    handleDelete?: (c: ContentItem) => void,
    className?: string,
    handleKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void,
} & Omit<SocialItemModalNavigationProps, "initialItemIndex">> = props => {
    const {organizationStore} = useStores();

    const schoolFeedListClassName = classNames({
        [styles.container]: true,
        [props.className || '']: props.className,
        [styles.containerFloatingBlocks]: organizationStore.organization.json_data?.settings?.appearance?.themeID === "2",
    })

    return <div className={schoolFeedListClassName}>
        <ul>
            {props.content.reduce((acc: Array<Array< IReactiveEventContentItem | IReactiveNewsContentItem | IReactiveCourseWorkContentItem>>, curr) => {
                if (acc.length === 0) {
                    // this is the first item, so just push the current item into the list
                    acc.push([curr]);
                } else {
                    const lastGroupAdded = acc[acc.length - 1];
                    const lastItemAdded = lastGroupAdded[lastGroupAdded.length - 1];
                    let shouldAddToLastGroup = false;

                    if (isEvent(curr) && (
                        !lastItemAdded.is_event || (
                            isEvent(lastItemAdded) && lastItemAdded.json_data.event.start.split("T")[0].replaceAll("/", "-") !== curr.json_data.event.start.split("T")[0].replaceAll("/", "-")
                        )
                    )) {
                        /* First and foremost, we check dates. If current item is a date, it should ALWAYS start a new group
                        UNLESS it is the same date as the previous item. */
                        shouldAddToLastGroup = false;
                    } else if (curr.organization?.id === lastItemAdded.organization?.id && isEvent(curr) && isEvent(lastItemAdded)) {
                        /* If current event item is from the same organization as the previous item, and display the same date,
                         we will group them together */
                        shouldAddToLastGroup = true;
                    } else {
                        // Otherwise, we start a new group.
                        shouldAddToLastGroup = false;
                    }

                    shouldAddToLastGroup === true ? lastGroupAdded.push(curr) : acc.push([curr]);
                }
                return acc;
            }, []).map((arrayOfItems) => { // this is an array of item objects that all have the same image or lack thereof but have the same source

                return <li key={arrayOfItems[0].id}>
                    <ListItemGroup
                        showMedia={props.showMedia}
                        allowCuration={props.allowCuration}
                        items={arrayOfItems}
                        handleDelete={props.handleDelete}
                        getItemAtIndex={props.getItemAtIndex}
                        totalItemCount={props.totalItemCount}
                        handleKeyDown={props.handleKeyDown}
                    />
                    <hr/>
                </li>
            })}
        </ul>
    </div>
}

export default SchoolFeedList;
